import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import SearchBar from "../../../Components/Utils/SearchBar";
import Breadcrumb from "../../../Components/Utils/Breadcrumb";
import { GetAccess } from "../../../Components/Utils/roles";
import { CreateButton } from "../../../Components/Utils/Buttons";

const FormLayout = ({
  getData = () => {},
  CreateAccess = false,
  children,
  searchValue = "",
  searchFun = () => {},
  total = { total },
}) => {
  let { pathname } = useLocation();
  const [module, setModule] = useState("");
  const navigate = useNavigate();

  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (pathname == `/forms/insforms`) {
      setModule("Inspection Forms");
    }
    else {
      setModule("Invalid");
    }
  }, [pathname]);

  let LinkItem = [
    {
      label: "Inspection Forms",
      link: `/forms/insforms`,
      access: GetAccess("insforms_view"),
    },
  ];

  return (
    <div className=" w-full  h-full py-2 px-4 overflow-hidden">
      <div className="md:flex justify-between w-full my-0.5">
        <Breadcrumb items={[{ name: module }]} />

        <div className=" flex justify-end items-center gap-3 ">
          <form className="flex items-center gap-3 mx-0" onSubmit={getData}>
            <SearchBar handleChange={searchFun} value={searchValue} />
          </form>
           {CreateAccess && (
                      <Link to={`${pathname}/create`}>
                        <CreateButton label="New Form" />
                      </Link>
                    )}
        </div>
      </div>

      <div className="w-full overflow-x-auto whitespace-nowrap scrollbar-hide md:flex  gap-x-10 mt-0.5">
        <div className="inline-flex items-center gap-x-1">
          {LinkItem &&
            LinkItem.map((item, i) => {
              const isActive = item?.link === pathname;

              return (
                <>
                  {item.access && (
                    <Link
                      to={item?.link}
                      key={item?.link}
                      className={`px-4 py-1 rounded-t-md text-xs 2xl:text-sm font-medium 
                       ${
                         isActive
                           ? "bg-baseColor-primary text-white"
                           : "bg-white text-baseColor-primary border-b-2 border-baseColor-primary"
                       }`}
                    >
                      {item?.label || ""}
                    </Link>
                  )}
                </>
              );
            })}
        </div>
        <div className="  rounded-md md:grid grid-cols-4 gap-x-4 text-xs px-2 font-medium mt-0.5">
          <div className="sm:mt-0 mt-1 h-auto border rounded-full mr-3 border-baseColor-primary text-xs inline-flex w-auto flex-shrink-0 justify-center overflow-hidden">
            <p className="w-auto bg-white text-black px-2 flex items-center justify-center">
              Total
            </p>
            <p className="bg-baseColor-primary w-auto text-white px-2 flex items-center justify-center">
              {total || "0"}
            </p>
          </div>
        </div>
      </div>

      <div className=" w-full h-[calc(100vh-211px)] md:h-[calc(100vh-165px)]  ">{children}</div>
    </div>
  );
};

export default FormLayout;
